"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumericOperators = exports.AlphaNumericOperators = exports.FilterOperator = void 0;
var FilterOperator;
(function (FilterOperator) {
    FilterOperator["Is"] = "is";
    FilterOperator["IsNot"] = "isNot";
    FilterOperator["Includes"] = "includes";
    FilterOperator["DoesNotInclude"] = "doesNotInclude";
    FilterOperator["StartsWith"] = "startsWith";
    FilterOperator["EndsWith"] = "endsWith";
    FilterOperator["OneOf"] = "oneOf";
    FilterOperator["NotOneOf"] = "notOneOf";
    FilterOperator["GreaterThan"] = "GreatherThan";
    FilterOperator["GreaterThanOrEqual"] = "GreaterThanOrEqual";
    FilterOperator["LessThan"] = "LessThan";
    FilterOperator["LessThanOrEqual"] = "LessThanOrEqual";
})(FilterOperator = exports.FilterOperator || (exports.FilterOperator = {}));
exports.AlphaNumericOperators = [
    FilterOperator.Is,
    FilterOperator.IsNot,
    FilterOperator.Includes,
    FilterOperator.DoesNotInclude,
    FilterOperator.StartsWith,
    FilterOperator.EndsWith,
];
exports.NumericOperators = [
    FilterOperator.Is,
    FilterOperator.IsNot,
    FilterOperator.GreaterThan,
    FilterOperator.GreaterThanOrEqual,
    FilterOperator.LessThan,
    FilterOperator.LessThanOrEqual,
];
//# sourceMappingURL=Filter.js.map